<div class="modal-small-table-container" *ngIf="DATA?.length > 0">
  <table mat-table [dataSource]="DATA" class="w-100">
    <!-- IT HAS VALUES COLUMNS -->
    <ng-container [matColumnDef]="column.name" *ngFor="let column of COLUMNS">
      <!-- TITLE HEADER -->
      <th mat-header-cell *matHeaderCellDef [ngClass]="column?.className">
        {{ column.title }}
      </th>
      <!-- END TITLE HEADER -->
      <!-- VALUE OF ROW -->
      <td mat-cell 
          *matCellDef="let element"
          [ngClass]="column?.className"
          [innerHTML]="column.renderValue ? column.renderValue(element) : element[column?.name]">
      </td>
      <!-- END VALUE OF ROW -->
    </ng-container>
    <!-- END IT HAS VALUES COLUMNS -->
    <!-- STICKY HEADER -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <!-- END STICKY HEADER -->
    <!-- ROWS -->
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    <!-- END ROWS -->
  </table>
</div>